import { IBondGelemMarketReport } from 'services/bonds-helper';

export const PREFIX = 'REPORT_DELTA_SHEKEL_MARKET';

export type IReportDeltaShekelMarketItem = IBondGelemMarketReport & { __isSelected: boolean };
